module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hant/1-1872627efe81bac480978788eb5bbdf0.jpg";